import React from 'react';

function CollapseIcon() {
  return (
    <svg id="collapse-icon" width="16" height="9" viewBox="0 0 16 9" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.67729 0.264259L8.67727 0.264279C8.68724 0.273436 8.69718 0.282972 8.70711 0.292893L15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711C15.3166 9.09763 14.6834 9.09763 14.2929 8.70711L8 2.41421L1.70711 8.70711C1.31658 9.09763 0.683418 9.09763 0.292893 8.70711C-0.0976311 8.31658 -0.0976311 7.68342 0.292893 7.29289L7.29289 0.292893C7.67363 -0.0878409 8.28499 -0.0973856 8.67729 0.264259Z" // eslint-disable-line max-len -- Long lines acceptable for SVG
      />
    </svg>
  );
}

export default CollapseIcon;
